<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
              <a-form-item   style="margin-left: 10%;width: 80%">
                <div style="font-size: 16px;color:rgba(125, 133, 146, 1)"><span style="color: #ff0000;margin-right: 5px">*</span>优惠卷</div>
                <j-search-select-tag  placeholder="请选择优惠卷"
                                     v-decorator="['couponId', validatorRules.couponId]"
                                     :dictOptions="couponList"  />
              </a-form-item>
                <a-form-item style="margin-left: 10%;width: 80%">
                  <div style="font-size: 16px;color:rgba(125, 133, 146, 1)"><span style="color: #ff0000;margin-right: 5px">*</span>标签</div>
                  <j-dict-select-tag  placeholder="请选择标签"  :disabled="disabled" type="list"  v-decorator="['couponLabel', validatorRules.couponLabel]" :trigger-change="true" dictCode="coupon_label" />
                </a-form-item>
              <a-form-item  style="margin-left: 10%;width: 80%">
                <div style="font-size: 16px;color:rgba(125, 133, 146, 1)">发券理由</div>
                <a-textarea v-decorator="['remark']" rows="4" placeholder="请输入发券理由" />
              </a-form-item>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { getFileAccessHttpUrl,httpAction, getAction ,deleteAction} from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue,getDataSub,by_str } from '@/utils/util'
  export default {
    name: 'AddCouponForm',
    components: {

    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        confirmLoading: false,
        validatorRules: {
          couponId: {
            rules: [
              { required: true, message: '请选择优惠卷!'},
            ]
          },
          couponLabel:{
            rules: [
              { required: true, message: '请选择标签!'},
            ]
          }
        },
        url: {
          add: "/dm/dmCouponDriver/add"
        },
        couponList:[]

      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data

    },
    methods: {
      add (record) {
        this.edit(record);
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'driverId','couponId','remark','couponLabel'))
        })
        this.getCouponList();
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = this.url.add;

            let formData = Object.assign(this.model, values);
            httpAction(httpurl,formData,"POST").then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok',formData.areaName);
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'areaName'))
      },getCouponList(){
        this.couponList = []
        getAction("/dm/dmCoupon/queryAllList").then((res)=>{
          if(res.success){
            let coupon = res.result;
            if(coupon){
              for(let a in coupon){
                this.couponList.push({
                  text:coupon[a].couponName,
                  label:coupon[a].couponName,
                  value:coupon[a].id
                })
              }
            }
          }else{
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>

  /deep/ .ant-list-item-meta-description{
    max-width: 400px;
  }
</style>